export const notificationsIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.recent-section-bar',
    intro: 'Recent Notifications is where you can view all notifications for students from the last seven days. '
      + 'These notifications keep you up to date on student data. Review notifications often to keep up to date '
      + 'on student progress, growth, and areas where they may need support.',
  },
  {
    element: '.refresh-button',
    intro: 'Click here to see the most up to date notifications.',
  },
  {
    element: '.date-range',
    intro:'Select a start date and end date before selecting Filter. This will allow you to see notifications for the selected date range.',
  },
  {
    element: '.search-input',
    intro: 'Click here to search for a specific student name or alert.',
  },
  {
    element: '#select-th',
    intro: 'Select a box next to the alert to dismiss it to the History page for notifications. '
      + 'This allows you to dismiss the notification after you have reviewed it.',
  },
  {
    element: '.notification-section-actions .btn-dismiss',
    intro: 'Select this button to dismiss the selected notification to the History Notifications page.',
  },
  {
    element: '#alert-type-th',
    intro: 'See the alert type column to see whether the alert is a student celebration notification (star icon) or '
      + 'a student needs attention notification (red warning icon).',
  },
  {
    element: '#alert-th',
    intro: 'Select an alert to see the list of students, the notification, and the possible next steps to take.',
  },
  {
    element: '#where-to-look-th',
    intro: 'Select a link to explore the student data linked to the specific notification.',
  }
]
